import { ptacUnitActiveItem } from '@alpinehomeair/common';
import { ConfigurationType } from 'data/types';
import { PTAC_NON_ADJACENT_SHARE_REASON } from 'utils/ptac-design-issues';
import { PtacRoomsTouch } from 'utils/ptac-zone-click-types';

export function ptacZoneAddRefusal(
  configuration: ConfigurationType,
  zoneId: string,
  spaceId: string,
  roomsTouch: PtacRoomsTouch
): string | null {
  const unit = configuration.condensers.find((condenser) =>
    condenser.zones.some((zone) => zone.uniqueId === zoneId)
  );
  const host = unit ? ptacUnitActiveItem(unit) : null;
  if (
    !host ||
    host.structureItemId === spaceId ||
    roomsTouch(spaceId, host.structureItemId)
  ) {
    return null;
  }
  return PTAC_NON_ADJACENT_SHARE_REASON;
}
